export function findCells(container) {

  const cells = [];

  for (let index = 0; index < container.children.length; index++) {
    if (container.children[index].classList.contains('layout-cell') === true) {
      cells.push(container.children[index]);
    }
  }

  return cells;

}

// Neighbours in the value can show the other way round, as in row-reverse.
function measureGap(cells, index, origin) {

  const first = cells[index].getBoundingClientRect();
  const second = cells[index + 1].getBoundingClientRect();

  if (first.left <= second.left) {
    return { leftIndex: index, rightIndex: index + 1, x: Math.round((first.right + second.left) / 2 - origin.left) };
  }

  return { leftIndex: index + 1, rightIndex: index, x: Math.round((second.right + first.left) / 2 - origin.left) };

}

// The gaps between neighbouring cells, relative to the wrapper the handles are placed in.
export function measureGaps(wrapper, container) {

  const cells = findCells(container);
  const origin = wrapper.getBoundingClientRect();
  const containerRectangle = container.getBoundingClientRect();
  const top = Math.round(containerRectangle.top - origin.top);
  const height = Math.round(containerRectangle.height);
  const gaps = [];

  for (let index = 0; index < cells.length - 1; index++) {
    gaps.push({ ...measureGap(cells, index, origin), top, height });
  }

  return gaps;

}

// The space in the row that no item or gap takes.
export function measureFreeSpace(container) {

  const cells = findCells(container);
  const columnGap = parseFloat(window.getComputedStyle(container).columnGap) || 0;
  let used = columnGap * (cells.length - 1);

  for (let index = 0; index < cells.length; index++) {
    used = used + cells[index].getBoundingClientRect().width;
  }

  return container.clientWidth - used;

}

function measureContentWidth(element) {

  const style = window.getComputedStyle(element);

  return element.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);

}

// In a stack, a cell is only as wide as its item, so the room is the stack's width.
function findOuterBox(main) {

  const parent = main.parentElement;

  if (parent.classList.contains('layout-cell') === true && window.getComputedStyle(parent.parentElement).flexDirection.indexOf('column') === 0) {
    return parent.parentElement;
  }

  return parent;

}

// A row sized to its content can itself grow, up to the width of the block around it.
export function measureRoomAround(container) {

  const main = container.closest('.editor-node-main');

  if (main === null || main.parentElement === null) {
    return 0;
  }

  return Math.max(0, measureContentWidth(findOuterBox(main)) - main.getBoundingClientRect().width);

}

export function measureWidth(element) {
  return element.getBoundingClientRect().width;
}
